module.exports = __webpack_public_path__ + "img/OK.5441694d.svg";